// Where a session falls in a student's week, in the student's own timezone (FB-3). The marketplace
// day and time-of-day filters read this, so a Tokyo student filtering "Tuesday evening" sees what
// is Tuesday evening in Tokyo, not in the instructor's timezone or the browser's.
import { utcToZonedParts } from './timezone';

// Mirrors backend/src/lib/constants.js WEEKDAYS and TIME_OF_DAY (the two packages share no build).
export const WEEKDAYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'];
export const TIME_OF_DAY = { MORNING: 'morning', AFTERNOON: 'afternoon', EVENING: 'evening' };
// Mirrors backend SESSION_LEVEL. A session with no level (null) is open to all levels (FB-4).
export const SESSION_LEVEL = { BEGINNER: 'beginner', INTERMEDIATE: 'intermediate', ADVANCED: 'advanced' };

const SESSION_LEVEL_LABELS = {
  [SESSION_LEVEL.BEGINNER]: 'Beginner',
  [SESSION_LEVEL.INTERMEDIATE]: 'Intermediate',
  [SESSION_LEVEL.ADVANCED]: 'Advanced',
};
const ALL_LEVELS_LABEL = 'All levels';

// What a student reads for a session's level: its name, or "All levels" when none is set.
export function sessionLevelLabel(level) {
  return SESSION_LEVEL_LABELS[level] || ALL_LEVELS_LABEL;
}

// Morning before 12:00, afternoon 12:00–16:59, evening from 17:00, in the viewer's timezone.
const AFTERNOON_FROM_HOUR = 12;
const EVENING_FROM_HOUR = 17;

// utcToZonedParts numbers weekdays from Sunday (0); WEEKDAYS starts on Monday.
const DAY_BY_WEEKDAY = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];

// -> { day: 'mon'..'sun', timeOfDay: 'morning' | 'afternoon' | 'evening' }
export function sessionSlot(startAt, tz) {
  const { weekday, hour } = utcToZonedParts(new Date(startAt), tz);
  const timeOfDay = hour >= EVENING_FROM_HOUR ? TIME_OF_DAY.EVENING
    : hour >= AFTERNOON_FROM_HOUR ? TIME_OF_DAY.AFTERNOON
      : TIME_OF_DAY.MORNING;
  return { day: DAY_BY_WEEKDAY[weekday], timeOfDay };
}

// True when one session satisfies every chosen filter at once. An empty filter list means "any".
// A full session never matches: the filters promise a seat the student can book. A session with
// no level is open to all levels, so it matches whichever level the student picks.
export function sessionMatches(session, { days = [], timesOfDay = [], levels = [] } = {}, tz) {
  if (!session || !(session.seatsLeft > 0)) return false;
  if (levels.length && session.level != null && !levels.includes(session.level)) return false;
  if (!days.length && !timesOfDay.length) return true;
  const slot = sessionSlot(session.startAt, tz);
  if (days.length && !days.includes(slot.day)) return false;
  if (timesOfDay.length && !timesOfDay.includes(slot.timeOfDay)) return false;
  return true;
}
